import { WeatherData } from './../../classes/weather-data';
import { Component, OnInit, Input, OnChanges, SimpleChanges, Inject } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-weather-ui',
  templateUrl: './weather-ui.component.html',
  styleUrls: ['./weather-ui.component.css']
})
export class WeatherUIComponent implements OnInit, OnChanges {

  @Input() data: WeatherData;

  constructor(private title: Title, private meta: Meta, @Inject(DOCUMENT) private doc: any) { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.data && this.data) {
      // Update title/meta for SEO
      if (this.data.city && this.data.weather && this.data.weather.Temperature) {
        const title = `${this.data.city} — ${this.data.weather.Temperature}°C weather`;
        this.title.setTitle(title);
        this.meta.updateTag({ name: 'description', content: `Current temperature in ${this.data.city} is ${this.data.weather.Temperature}°C.` });
      }

      // Insert JSON-LD structured data if available
      if (this.data.weatherForecastSchema) {
        try {
          const id = 'weather-ld-json';
          let script = this.doc.getElementById(id);
          if (!script) {
            script = this.doc.createElement('script');
            script.type = 'application/ld+json';
            script.id = id;
            this.doc.head.appendChild(script);
          }
          script.text = JSON.stringify(this.data.weatherForecastSchema || {});
        } catch (e) {
          // ignore DOM errors
        }
      }
    }
  }

}
